import { ArrowDown, ShieldCheck, FileCheck2, MapPin, Camera } from 'lucide-react';
import { PACKAGES } from '@/lib/packages';
import { WhatsAppCta } from '@/components/home/WhatsAppCta';
import { HOME } from '@/constants/testIds';

export const Hero = () => (
  <>
    <section id="top" className="gg-hero" data-testid="home-hero">
      <img src="/gallery-2-800.webp" srcSet="/gallery-2-400.webp 400w, /gallery-2-800.webp 800w"
        sizes="100vw" width="800" height="536" fetchPriority="high" decoding="async"
        alt="Ilustrasi pemasangan kamera CCTV pada dinding luar rumah" className="gg-hero-photo" data-testid="hero-cctv-image" />
      <div className="gg-hero-shade" aria-hidden="true" />
      <div className="gg-container gg-hero-inner">
        <div className="gg-hero-copy">
          <p className="gg-eyebrow gg-hero-eyebrow" data-testid="hero-service-area"><MapPin size={14} /> PEMASANGAN CCTV · KL & SELANGOR</p>
          <h1 data-testid="hero-headline">CCTV Hikvision.<br />Pantau rumah,<br /><span>walau dari jauh.</span></h1>
          <p className="gg-hero-description" data-testid="hero-description">Goguard pasang kamera, NVR dan setup app. Anda boleh semak live view dan rakaman terus dari telefon.</p>
          <p className="gg-hero-price" data-testid="hero-starting-price"><span>Pakej lengkap dari</span> <strong>{PACKAGES[0].price}</strong><span> / {PACKAGES[0].features[0].split(' ')[0]} kamera</span></p>
          <div className="gg-hero-actions">
            <WhatsAppCta testId={HOME.heroPrimaryCta} booking />
            <a href="#pakej" className="gg-hero-secondary" data-testid={HOME.heroSecondaryCta}>Bandingkan 4 pakej <ArrowDown size={16} /></a>
          </div>
          <p className="gg-hero-reassurance" data-testid="hero-booking-note">Site visit percuma di Lembah Klang. Semak quotation dahulu, tanpa komitmen pemasangan.</p>
        </div>
        <span className="gg-hero-caption" data-testid="hero-image-disclosure">Visual ilustrasi pemasangan</span>
      </div>
    </section>
    <div className="gg-trust-strip" data-testid="hero-trust-strip">
      <div className="gg-container gg-trust-grid">
        {[
          { Icon: Camera, title: 'Hikvision sahaja', detail: 'Satu ekosistem CCTV' },
          { Icon: ShieldCheck, title: 'Waranti 12 bulan', detail: 'Workmanship bertulis' },
          { Icon: FileCheck2, title: 'Bayaran 50/50', detail: 'Baki selepas handover' },
          { Icon: MapPin, title: 'Team Lembah Klang', detail: 'Sg Buloh · Damansara · KL · Selangor' },
        ].map(({ Icon, title, detail }, i) => <div className="gg-trust-item" key={title} data-testid={`hero-trust-${i}`}><Icon size={20} /><div><strong>{title}</strong><span>{detail}</span></div></div>)}
      </div>
    </div>
  </>
);

export default Hero;